export const enum RibbonId {
    // Ribbon Tabs
    Tab_Folder = 0,
    Tab_Home,
    Tab_Message,
    Tab_View,
    Tab_Format,

    // Groups
    Group_AddIns,
    Group_Format,
    Group_Clipboard,
    Group_Delete,
    Group_Download,
    Group_Encrypt,
    Group_File,
    Group_Find,
    Group_Groups,
    Group_ImmersiveReader,
    Group_Include,
    Group_Insights,
    Group_Move,
    Group_Move_and_Delete,
    Group_Names,
    Group_New,
    Group_Offline,
    Group_Print,
    Group_Protection,
    Group_QuickSteps,
    Group_Respond,
    Group_RibbonCustomizer,
    Group_Save,
    Group_Send,
    Group_Sensitivity,
    Group_Speech,
    Group_Sync,
    Group_Tags,
    Group_ToggleLeftPane,
    Group_Undo,
    Group_Voice,

    // Toolbar groups
    Group_Toolbar_Home,
    Group_Toolbar_Message,

    // Controls
    AddReminder,
    AddressBook,
    ShowFrom,
    AllCategories,
    Archive,
    AttachSig,
    Block,
    BrowseGroups,
    Categorize,
    CheckForAccessibilityIssues,
    CheckNames,
    ClearAllCategories,
    ClearFlag,
    Copy,
    CopyToFolder,
    CreateRule,
    Custom,
    Cut,
    DeleteItem,
    Dictate,
    DownloadDownloadHeaders,
    DynamicCategory1,
    DynamicCategory2,
    DynamicCategory3,
    Encrypt,
    FlagUnflag,
    FormatPainter,
    GetAddIns,
    HighImportance,
    IgnoreStopIgnore,
    ImmersiveReader,
    Insights,
    JunkFlyout,
    JunkNotJunk,
    LowImportance,
    ManageRules,
    MarkComplete,
    Move,
    /**
     * Controls for "new" actions are excluded from being disabled in secondary reading panes.
     * Any new "new" controls should also be added to getIsButtonDisabled.ts
     */
    NewContact,
    NewEvent,
    NewGroup,
    NewItems,
    NewMessage,
    NewMessageSplitButton,
    NewNote,
    NewTask,
    NewTeamsMeeting,
    NewYammerPost,
    /* End of "new item" controls */
    NextWeek,
    NoDate,
    NormalImportance,
    OfflineWorkOffline,
    OtherFolder,
    Paste,
    Phishing,
    PinUnpin,
    Print,
    QuickStepsGallery,
    ReadAloud,
    ReadUnread,
    ReplyWithMeeting,
    ReportMessage,
    RespondForward,
    RespondReply,
    RespondReplyAll,
    RibbonCustomizer,
    Rules,
    Save,
    SendAll,
    SendReceiveAllFolders,
    SendReceiveGroups,
    Sensitivity,
    Sensitivity_LearnMore,
    SetImportance,
    SetQuickActions,
    SetQuickClick,
    ShowHideFrom,
    ShowMessageOptions,
    Snooze,
    Sweep,
    SwitchDraftFormat,
    SyncCancelAll,
    SyncShowProgress,
    ThisWeek,
    Today,
    ToggleLeftPane,
    Tomorrow,
    Undo,
    Unsnooze,
    UpdateFolder,

    // Toolbar ribbon-only buttons
    DiscardDraft,
    SendDraft,

    // Flag/Unflag Options
    FlagCompleteToday,
    FlagCompleteTomorrow,
    FlagCompleteThisWeek,
    FlagCompleteNextWeek,
    FlagCompleteNoDate,
    FlagMarkComplete,
    FlagClearFlag,

    // Ribbon Command "MoveTo" IDs
    AlwaysMoveToFocusedInbox,
    AlwaysMoveToOtherInbox,
    MoveAllMessagesFrom,
    MoveToDifferentFolder,
    MoveToFocusedInbox,
    MoveToOtherInbox,
    MoveToCreateNewFolder,

    // Ribbon Command "Categorize" IDs
    CategorizeNewCategory,
    CategorizeAllCategories,
    CategorizeClearCategories,
    CategorizeManageCategories,

    // Ribbon AssignPolicy IDs
    AssignPolicy,
    AssignPolicyArchiveInherit,
    AssignPolicyDeleteInherit,
    AssignPolicyParentTagFlyout,

    // Attach file / link (compose)
    AttachFile,
    AttachFileFromComputer,
    AttachFileFromOnlineLocation,
    AttachFileFromUpload,
    ShowLinkDialog,

    // Dynamic menu button (for menus with a "check" selection)
    DynamicMenuButton,

    /**************************************************************************/
    /* Do NOT add RibbonIds below this line. Add all new ids above this line. */
    /**************************************************************************/
    __LENGTH, // Used to hold the length of this enum. Used to determine between user-defined groups and default groups.
}

export function getNumericRibbonId(id: RibbonId | string): number {
    return typeof id == 'string' ? parseInt(id) : id;
}

export const getStringRibbonId = (id: RibbonId) => id.toString();
